import React from "react";
import {
  Box,
  Heading,
  Text,
  Table,
  Thead,
  Tr,
  Th,
  Td,
  Tbody,
  Badge,
  VStack,
  Button,
  HStack,
  useToast,
} from "@chakra-ui/react";

const mockCRMData = [
  {
    clientId: "c001",
    name: "Dr. Alice Simmons",
    facility: "Oakwood Dermatology",
    email: "alice@oakderm.com",
    phone: "555-123-4567",
    status: "Active",
    createdAt: "2024-12-10",
    assignedRep: "john.doe@curagenesis.com",
    tasks: [
      {
        taskId: "t001",
        title: "Send updated exosome pricing",
        dueDate: "2025-04-30",
        assignedTo: "linda.f@curagenesis.com",
        completed: false,
      },
      {
        taskId: "t002",
        title: "Confirm interest in wound care webinar",
        dueDate: "2025-04-28",
        assignedTo: "john.doe@curagenesis.com",
        completed: true,
      },
    ],
  },
  {
    clientId: "c002",
    name: "Dr. Bryan Cole",
    facility: "Elite Aesthetics",
    email: "bcole@eliteaesthetics.org",
    phone: "555-222-7890",
    status: "Onboarding",
    createdAt: "2025-03-25",
    assignedRep: "karen.r@curagenesis.com",
    tasks: [
      {
        taskId: "t003",
        title: "Collect BAA and PA forms",
        dueDate: "2025-04-25",
        assignedTo: "karen.r@curagenesis.com",
        completed: false,
      },
    ],
  },
  {
    clientId: "c003",
    name: "Dr. Charles Kim",
    facility: "ReGen Health Group",
    email: "ckim@regenhg.com",
    phone: "555-333-9876",
    status: "Inactive",
    createdAt: "2024-08-15",
    assignedRep: "matthew.b@curagenesis.com",
    tasks: [],
  },
];

const CRMTool = () => {
  const toast = useToast();

  const handleSendReminder = (taskTitle) => {
    toast({
      title: `Reminder sent for: ${taskTitle}`,
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  };

  return (
      <Box p={6}>
        <Heading mb={6}>Client Relationship Manager</Heading>
        {mockCRMData.map((client) => (
          <Box
            key={client.clientId}
            borderWidth={1}
            borderRadius="lg"
            p={4}
            mb={6}
            bg="white"
            shadow="md"
          >
            <HStack justify="space-between" align="start" mb={4}>
              <VStack align="start" spacing={1}>
                <Text fontSize="lg" fontWeight="bold">
                  {client.name} ({client.facility})
                </Text>
                <Text>Email: {client.email}</Text>
                <Text>Phone: {client.phone}</Text>
                <Text>Created At: {client.createdAt}</Text>
                <Text>Assigned Rep: {client.assignedRep}</Text>
              </VStack>
              <Badge
                colorScheme={
                  client.status === "Active"
                    ? "green"
                    : client.status === "Onboarding"
                    ? "yellow"
                    : "gray"
                }
              >
                {client.status}
              </Badge>
            </HStack>

            {client.tasks.length > 0 && (
              <Box mt={4}>
                <Heading size="sm" mb={2}>
                  Tasks
                </Heading>
                <Table variant="simple" size="sm">
                  <Thead>
                    <Tr>
                      <Th>Title</Th>
                      <Th>Due Date</Th>
                      <Th>Assigned To</Th>
                      <Th>Status</Th>
                      <Th>Action</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {client.tasks.map((task) => (
                      <Tr key={task.taskId}>
                        <Td>{task.title}</Td>
                        <Td>{task.dueDate}</Td>
                        <Td>{task.assignedTo}</Td>
                        <Td>
                          <Badge colorScheme={task.completed ? "green" : "orange"}>
                            {task.completed ? "Completed" : "Pending"}
                          </Badge>
                        </Td>
                        <Td>
                          {!task.completed && (
                            <Button
                              size="xs"
                              colorScheme="teal"
                              onClick={() => handleSendReminder(task.title)}
                            >
                              Send Reminder
                            </Button>
                          )}
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </Box>
            )}
          </Box>
        ))}
      </Box>
  );
};

export default CRMTool;